import { baseApi } from 'src/Services/api'

export enum Role {
  SALES = 'SALES',
  ADMIN = 'ADMIN',
  LEAD_MANAGER = 'LEAD_MANAGER',
}

export interface User {
  id: number
  email: string
  firstName?: string
  lastName?: string
  role: Role
  createdAt: string
  updatedAt: string
  phone: string
}

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  password: string
  firstName?: string
  lastName?: string
  phone?: string
  role?: string
}

export interface AuthResponse {
  user: User
  token: string
}

type ProfileResponse = User

export interface VerifyResponse {
  success: boolean
  data: {
    userId: number
    email: string
    role: string
  }
}

export interface Manager {
  id: number
  email: string
  firstName?: string
  lastName?: string
  role: Role
}

export interface ManagersResponse {
  success: boolean
  data: Manager[]
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),

    getProfile: builder.query<ProfileResponse, void>({
      query: () => '/auth/profile',
    }),

    getAllManagers: builder.query<ManagersResponse, void>({
      query: () => '/auth/managers',
    }),
  }),
  overrideExisting: true,
})

export const { useLoginMutation, useGetProfileQuery, useGetAllManagersQuery } =
  authApi
